import UserRequest from '../request/UserRequest'
import OrderRequest from '../request/OrderRequest'
import CourseRequest from '../request/CourseRequest'
import ServiceRequest from '../request/ServiceRequest'
import LessonRequest from '../request/LessonRequest'
import ItemRequest from '../request/ItemRequest'
import HomeRequest from '../request/HomeRequest'
import CartRequest from '../request/CartRequest'
import CommentRequest from '../request/CommentRequest'
import CategoriesRequest from "../request/CategoriesRequest";
import PostRequest from '../request/PostRequest'
import LoginRequest from '../request/LoginRequest'
import OtpRequest from '../request/OtpRequest'
import OrderHistoryRequest from '../request/OrderHistoryRequest'
import VirtualRequest from "../request/VirtualRequest";
import FlashSaleRequest from '../request/FlashSaleRequest'

const requestMap = {
  UserRequest,
  OrderRequest,
  ItemRequest,
  ServiceRequest,
  CourseRequest,
  CartRequest,
  CommentRequest,
  PostRequest,
  LessonRequest,
  HomeRequest,
  OtpRequest,
  LoginRequest,
  OrderHistoryRequest,
  CategoriesRequest,
  VirtualRequest,
  FlashSaleRequest
}

const instances = {}

export default class RequestFactory {

  static getRequest(classname) {
    let RequestClass = requestMap[classname]
    if (!RequestClass) {
      throw new Error('Invalid request class name: ' + classname)
    }

    let requestInstance = instances[classname]
    if (!requestInstance) {
      requestInstance = new RequestClass()
      instances[classname] = requestInstance
    }

    return requestInstance
  }

}



// WEBPACK FOOTER //
// ./src/communicate/RequestFactory.js